import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { ArrowDown } from 'lucide-react';
import { useRecoilValue } from 'recoil';
import { showPoweredBySelector, variantSelector } from '@/state/config';
export const ScrollToBottomButton = ({ onClick, }) => {
    const showPoweredBy = useRecoilValue(showPoweredBySelector);
    const { isFiserv } = useRecoilValue(variantSelector);
    return (_jsx("button", { className: cn('bottom-30 z-1 absolute left-1/2 flex h-8 w-8 -translate-x-1/2 cursor-pointer items-center justify-center', 'bg-bg-muted hover:bg-bg-muted rounded-full shadow-md transition-all', {
            'bottom-40': showPoweredBy,
            'bottom-44': isFiserv,
        }), onClick: onClick, children: _jsx(ArrowDown, { className: "text-text-secondary-foreground h-4 w-4" }) }));
};
